import { TextInput } from '@rbilabs/components-library/build/components/text-input';
import styled from 'styled-components';

import { ActionButton } from 'components/action-button';
import { ActionsheetWrapper } from 'components/action-sheet';

export const Container = styled.div<{ $keyboardHeight?: number }>`
  column-gap: 1rem;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-block-end: ${props => `${props.$keyboardHeight}px`};
`;
export const StyledInput = styled(TextInput)`
  margin: 0.5rem 0;
`;
export const StyledButton = styled(ActionButton)`
  background-color: ${Styles.color.white};
  border: 1px solid ${Styles.color.primary};
  color: ${Styles.color.primary};
  margin: 0.5rem 0;

  &:disabled {
    border: initial;
    color: ${Styles.color.grey.five};
  }
  &:hover {
    color: ${Styles.color.white};
  }
`;
export const StyledActionSheet = styled(ActionsheetWrapper)`
  padding: 0;
`;
